'use client';

import AlgoliaPopularProduct from 'components/commercetools-ui/organisms/algoliaPopularProduct';
import React from 'react';
import useLocale from 'helpers/hooks/useLocale';
import { DataForPopularProduct } from 'types/next';
import { TasticProps } from '../types';

const AlgoliaPopularProductTastic = ({ data }: TasticProps<any>) => {
  const { locale } = useLocale();
  const searchQueryAttribute =
    data.data?.dataSource?.searchQueryAttribute?.[locale] || data.data?.dataSource?.searchSlugAttribute?.[locale];
  const contentName = data?.contentName?.[locale] || data?.contentName || '';
  const shopAllLink = data?.shopallLink?.[locale] || data?.shopallLink || '';
  return (
    <>
      <AlgoliaPopularProduct
        searchQueryAttribute={searchQueryAttribute}
        contentName={contentName}
        shopAllLink={shopAllLink}
      />
    </>
  );
};

export default AlgoliaPopularProductTastic;
